import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSubscription } from "react-stomp-hooks";
import { flyDayDispatch } from "../../reduce/actions";

/**
 * Custom hook for STOMP subscription to flyday updates
 */
export const useStompSubscription = (dayDate) => {
  const dispatch = useDispatch();

  const onMessageReceived = useCallback((payload) => {
    const message = JSON.parse(payload.body);
    if (message.statusCodeValue === 200) {
      const flyDayMessage = message.body;
      if (dayDate !== flyDayMessage.day) {
        return;
      }
      dispatch(flyDayDispatch(flyDayMessage));
    }
  }, [dayDate, dispatch]);

  useSubscription("/topic/flyday", onMessageReceived);
};

